import Vue from 'vue'

Vue.filter('toDate', function(value, arg) {
    const time = Vue.moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('en')
    return time.format('DD MMM, YYYY')
})

Vue.filter('toMoney', function(value, arg) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})



// WEBPACK FOOTER //
// ./src/filters/index.js